export default __webpack_public_path__ + "static/ut-screen-android-mobile@2x-cd9978a832431fcec2e703d8d81d488c.webp";